<template>
  <div class="agreement" v-if="!agree">
    <p>
      Questo sito Web utilizza i cookie per migliorare il servizio. Usando il sito accetti questo utilizzo.
      <a href="#" v-on:click="close()">Chiudi</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'CookiesAgreement',
  data: function() {
    return {
      agree: false
    };
  },
  mounted: function() {
    this.agree = localStorage.getItem("cookies-agreement") == "true";
  },
  methods: {
    close() {
      localStorage.setItem("cookies-agreement", true);
      this.agree = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #e7e7e7;
  text-align: center;
  padding: 10px;
}

p {
  font-size: 15px;
  margin: 0;
}
</style>
